import React, { useContext } from 'react';
import { CORE_INVITES_IN_JIRA_PROJECTS } from './constants';
import { useExperimentalFeatures } from '../experimentalFeatures';
export interface CoreInvitesJiraProjectContextProps {
	children: React.ReactNode;
}

type CoreInvitesJiraProjectState = {
	isCoreInvitesInJiraProjectEnabled: boolean;
};

export const CoreInvitesJiraProjectStateContext = React.createContext<
	CoreInvitesJiraProjectState | undefined
>(undefined);

export const FLOW_CORE_INVITES = 'core-invites';

export const CoreInvitesJiraProjectContext = ({
	children,
}: CoreInvitesJiraProjectContextProps): React.JSX.Element => {
	const { coreInvitesInJiraProjects: coreInvitesInJiraProjectsCohort } = useExperimentalFeatures();
	const isCoreInvitesInJiraProjectEnabled =
		coreInvitesInJiraProjectsCohort === CORE_INVITES_IN_JIRA_PROJECTS.INVITE_ONLY ||
		coreInvitesInJiraProjectsCohort === CORE_INVITES_IN_JIRA_PROJECTS.INVITE_RA;

	return (
		<CoreInvitesJiraProjectStateContext.Provider
			value={{
				isCoreInvitesInJiraProjectEnabled,
			}}
		>
			{children}
		</CoreInvitesJiraProjectStateContext.Provider>
	);
};

export const useCoreInvitesJiraProjectContext = () => {
	const state = useContext(CoreInvitesJiraProjectStateContext);

	if (state === undefined) {
		throw new Error(
			'useCoreInvitesJiraProjectContext must be used within a CoreInvitesJiraProjectStateContextProvider',
		);
	}

	return state;
};
